export default __webpack_public_path__ + "static/media/cart-remove.5a5ebb2b.svg";